import { BybAnimatedPill } from "@Components/common/byb-ds";
import { AppContext } from "@Context/common/general/context";
import useI18n from "@i18n";
import { Box } from "@mui/material";
import { useContext, useState } from "react";
import ScanRateScoreMaxedDialog from "./scan-rate-score-maxed-dialog";

interface IScanRateScoreMaxedIndicator {
  stopPropagation?: boolean;
}

const ScanRateScoreMaxedIndicator = ({ stopPropagation = false }: IScanRateScoreMaxedIndicator) => {
  const { i18n } = useI18n();
  const { state } = useContext(AppContext);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const isDialogEnabled = !state.device.isMobile;
  const pillLabel = i18n("session-results.scan-rate-maxed.pill");

  const handlePillClick = () => {
    if (!isDialogEnabled) {
      return;
    }

    setIsDialogOpen(true);
  };

  const pill = (
    <BybAnimatedPill onClick={isDialogEnabled ? handlePillClick : undefined}>{pillLabel}</BybAnimatedPill>
  );

  return (
    <>
      {stopPropagation ? (
        <Box
          onClick={event => event.stopPropagation()}
          onKeyDown={event => {
            if (event.key === "Enter" || event.key === " ") {
              event.stopPropagation();
            }
          }}
        >
          {pill}
        </Box>
      ) : (
        pill
      )}
      {isDialogEnabled && <ScanRateScoreMaxedDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} />}
    </>
  );
};

export default ScanRateScoreMaxedIndicator;
